import { PATIENT_CODE_PREFIX, PRESCRIPTION_CODE_PREFIX } from '@/constants/clinic'

export const createId = (): string => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID()

    return `id-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
}

export const formatPatientCode = (value: number): string => `${PATIENT_CODE_PREFIX}-${String(value).padStart(4, '0')}`

export const formatPrescriptionNumber = (value: number): string => `${PRESCRIPTION_CODE_PREFIX}-${String(value).padStart(4, '0')}`

export const parseCodeNumber = (code: string): number => {
    const match = code.match(/(\d+)$/)

    return match ? Number(match[1]) : 0
}
